// test2345
(2345 && 0);
